const replaceCommas = (commaNumber: string): number => {
  return Number(commaNumber.toString().replace(/,/g, '.'));
};

export default replaceCommas;
